function ImageTitle(props) {
    return (
      <>
        <img className="mw-100" src={props.src} alt={props.alt} className="image-center" />
      </>
    );
  }
  
export default ImageTitle;